// extracted by mini-css-extract-plugin
module.exports = {"contents":"_2pVoSocwgWfH3XT4sVXU70","contractLayout":"_1lHuZwhVm1NphSgJ9dlbyy"};